module.exports = __webpack_public_path__ + "DINNextLTPro-UltraLightCond.eot?f65b6d6c8c05f770955a4899c7a4c025";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-UltraLightCond.eot
// module id = 305
// module chunks = 0